import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * @deprecated Use firstValueFrom or lastValueFrom from RXJS
 */
export function oneResultFrom<T>(ob: Observable<T>): Promise<T> {
  return ob.pipe(take(1)).toPromise();
}

export function oneResultFromEach<V1>(ob: [Observable<V1>]): Promise<V1>[];
export function oneResultFromEach<V1, V2>(ob: [Observable<V1>, Observable<V2>]): [Promise<V1>, Promise<V2>];
export function oneResultFromEach<V1, V2, V3>(
  ob: [Observable<V1>, Observable<V2>, Observable<V3>],
): [Promise<V1>, Promise<V2>, Promise<V3>];
export function oneResultFromEach<V1, V2, V3, V4>(
  ob: [Observable<V1>, Observable<V2>, Observable<V3>, Observable<V4>],
): [Promise<V1>, Promise<V2>, Promise<V3>, Promise<V4>];

export function oneResultFromEach(ob: Observable<any>[]): Promise<any>[] {
  return ob.map((o) => oneResultFrom(o));
}
